module.exports = __webpack_public_path__ + "img/facebook-yellow.72757ad5.svg";